import { endpoint } from './endpoint';
import fetch from 'isomorphic-unfetch';

export function postNewLead(data): Promise<any> {
  const url = endpoint + '/v1/lead';
  const init = {
    method: 'post',
    body: JSON.stringify({ ...data }),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  };
  return fetch(url, init).then((res) => res.json());
}

export function checkIfUserExist(email): Promise<any> {
  const url = endpoint + `/v1/lead/check-email/${email}`;
  const init = {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  };
  return fetch(url, init).then((res) => res.json());
}

export function getLinkMeetingFromLead(): Promise<any> {
  const url = endpoint + `/v1/lead/link-meeting`;
  const init = {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  };

  return fetch(url, init).then((res) => res.json());
}

export function getLead(id): Promise<any> {
  const url = endpoint + `/v1/lead/${id}`;
  const init = {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  };
  return fetch(url, init).then((res) => res.json());
}
